export default __webpack_public_path__ + "static/Tek_Dinosaur_Gateway-fdb66413175e8ccdb55b163743b2e736.png";